import React from 'react';
import { Container, Row, Col } from 'react-grid-system';
import '../styles/about.css';
import '../styles/home.css';
import jnvm from '../media/jnvmau.jpg';
import jnvk from '../media/jnv-kottayam.jpeg';
import iitd from '../media/iitd.jpeg';
import jnvl from '../media/jnv-logo.jpeg';
import iitdl from '../media/Logo-IITD.jpg';
import me from '../media/me2.jpg';
import { projects } from '../constants/projects';
function About() {
  return (
    <div className='about'>
      <ul class="background">
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
      </ul>
      <h1 className='border-down'>About Me</h1>
      <div className='flex'>
        <img src={me} alt="" className='ab-img' />
        <div className='text'>
          <h4>
            Hello there!<br></br> It's great to have you here. <br></br> My name is Rishabh Kumar, and I'm a Senior Undergraduate in the Computer Science Department at IIT Delhi. While academics keep me busy, I love to step beyond coursework to explore and experiment with technology. Whether it’s building tech systems, tinkering with hardware, or diving into a coding project, I enjoy taking on challenges that help me grow. But there’s more to me than just tech! When I’m not working on a project, you’ll find me playing badminton, listening to music, or dreaming about my next adventure as I love to travel and explore the world. These passions keep me energized and grounded, offering a perfect balance to my tech pursuits.<br></br>Thanks for stopping by—I hope we connect over shared interests and experiences!
          </h4>
          <a href="#project">
          <button className="glow-on-hover" type="button">My Projects</button>
          </a>
        </div>
      </div>
      <hr />
      <h1 className='border-down'>My Education</h1>
      <div className="container1">
        <img src={jnvm} alt="" className="edu-img" />
        <div className="content">
          <h2>Jawahar Navodaya Vidyalaya<br></br> Mau, UP</h2>
          <p className="date">Class X, CBSE Board, 2019</p>

        </div>
        <img src={jnvl} alt="" className="edu-img" />

      </div>
      <div className="container1">
        <img src={jnvk} alt="" className="edu-img" />
        <div className="content">
          <h2>Jawahar Navodaya Vidyalaya<br></br> Kottayam, Kerala</h2>
          <p className="date">Class XII, CBSE Board, 2021</p>

        </div>
        <img src={jnvl} alt="" className="edu-img" />

      </div>
      <div className="container1">
        <img src={iitd} alt="" className="edu-img" />
        <div className="content">
          <h2>Indian Institute of Technology<br></br>New Delhi, Delhi</h2>
          <p className="date">B. Tech., Computer Science, 2025</p>

        </div>
        <img src={iitdl} alt="" className="edu-img" />
      </div>
      <hr />
      <div className='flex'>
        <div className='bottom'>
          <h1 className='border-down'>My Technical Skills</h1>
          <Container style={{ paddingTop: "30px" }}>
            <Row>
              <Col xs={4} style={{ zIndex: "-1" }}>
              <i class='bx bxl-python hobby'></i><br />
                <span>Python</span>
              </Col>
              <Col xs={4} style={{ zIndex: "-1" }}>
              <i class='bx bxl-c-plus-plus hobby' ></i><br />
                <span>C++</span>
              </Col>
              <Col xs={4} style={{ zIndex: "-1" }}>
                <i class='bx bx-math hobby'></i><br />
                <span>Problem Solving</span>
              </Col>
            </Row>
            <Row>
              <Col xs={4} style={{ zIndex: "-1" }}>
                <i class='bx bxl-react hobby'></i><br />
                <span>ReactJS</span>
              </Col>
              <Col xs={4} style={{ zIndex: "-1" }}>
              <i class='bx bxl-apple hobby'></i><br />
                <span>iOS Development</span>
              </Col>
              <Col xs={4} style={{ zIndex: "-1" }}>
              <i class='bx bxl-git hobby'></i><br />
                <span>Git/GitHub</span>
              </Col>
            </Row>
          </Container>
        </div>
        <div className='bottom'>
          <h1 className='border-down'>My Hobbies</h1>
          <Container style={{ paddingTop: "30px" }}>
            <Row>
              <Col xs={4} style={{ zIndex: "-1" }}>
              <i class='bx bx-movie-play hobby'></i><br />
                <span>Movies and Series</span>
              </Col>
              <Col xs={4} style={{ zIndex: "-1" }}>
              <i class='bx bx-book-reader hobby'></i><br />
                <span>Reading</span>
              </Col>
              <Col xs={4} style={{ zIndex: "-1" }}>
                <i class='bx bxs-music hobby'></i><br />
                <span>Music</span>
              </Col>
            </Row>
            <Row>
              <Col xs={4} style={{ zIndex: "-1" }}>
                <i class='bx bxs-plane-alt hobby'></i><br />
                <span>Travelling</span>
              </Col>
              <Col xs={4} style={{ zIndex: "-1" }}>
                <i class='bx bx-dumbbell hobby'></i><br />
                <span>Gym</span>
              </Col>
              <Col xs={4} style={{ zIndex: "-1" }}>
                <i class='bx bx-run hobby'></i><br />
                <span>Sports</span>
              </Col>
            </Row>
          </Container>
        </div>
      </div>
      <hr />
      <div id="project">
        <h1 className='border-down'>My Projects</h1>
        
        {projects.map((project) => (
          <>
          <div className='projects'>
            <h3>{project.topic}</h3>
            <p className='date'>Guide: {project.guide}</p>
            {project.desc.map((element) => (
              <p>&rarr; {element.point}</p>
            ))}
            <a href={project.link}>Project Link</a>
            </div>
          </>
        ))}
        
      </div>
    </div>
  );
}

export default About;
